'use strict';

const $ = require('jquery');

class ScrollMenu {

    constructor() {

        this.createPageNavigation();

    }

    checkActivePageSection() {
        let $activeScroll = $('[data-anchor]');

        if ($activeScroll.length > 0) {

            let headerHeight = $('.main-header').height();
            let $fixedPageNavigation = $('.fixed-page-navigation');
            let fixedPageNavigationTop = $fixedPageNavigation.offset().top;

            //  Calculate the width of the floating menu wrapper
            App.Globals.$window.on('load resize', function () {

                this.floatingMenuWidth = $fixedPageNavigation.parent().width();

            });

            App.Globals.$window.on('load scroll', function () {

                let windowTop = App.Globals.$window.scrollTop();

                //  Loop through all the products to check which one is currently in the viewport
                $activeScroll.each(function () {

                    let $this = $(this);

                    if ((windowTop + headerHeight + 100) >= $this.offset().top) {

                        //  Remove all 'selected' classes from the floating menu
                        $fixedPageNavigation.find('a').removeClass('selected');

                        //  Add class 'selected' to the currently in view product
                        $('[href="#' + $this.attr('id') + '"]').addClass('selected');

                    }

                });

                if ((windowTop + headerHeight) > fixedPageNavigationTop) {
                    App.Globals.$body.addClass('scrolled-page-navigation');
                }
                else {
                    App.Globals.$body.removeClass('scrolled-page-navigation');
                }

            });

        }
    }

    createPageNavigation() {
        let $contentElement = $('.ce-scroll-menu');

        if ($contentElement.length > 0) {

            let $anchorLinks = $('[data-anchor]');
            let $createArea = $('.js-create-page-navigation');

            $anchorLinks.each((index, element) => {
                $createArea.append(`<li><a href="#${element.getAttribute('id')}" data-scroll data-scroll-offset=".ce-scroll-menu.navigation">${element.getAttribute('data-anchor-title')}</a></li>`);
            });

            if ($contentElement.hasClass('navigation')) {
                this.checkActivePageSection();
            }
        }
    }

}

module.exports = ScrollMenu;
